import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { GATE_STAGE, geolocationCopy } from '../../constants/geolocationCopy';
import { getCopySegments } from '../../helpers/getCopySegments';
import { styles } from './styles';

const useStyles = makeStyles(styles);

const LocationGateModal = ({ stage, onPrimary, onCancel, action }) => {
  const classes = useStyles();

  if (!stage) return null;

  const copy = geolocationCopy[stage];

  return (
    <Dialog
      open
      onClose={onCancel}
      aria-labelledby="location-gate-title"
      PaperProps={{ classes: { root: classes.dialogRoot } }}
    >
      <DialogTitle disableTypography id="location-gate-title">
        <Typography variant="h6">{copy.title}</Typography>
      </DialogTitle>
      <DialogContent>
        {copy.body?.map((paragraph) => (
          <Typography key={paragraph} variant="body1" className={classes.paragraph}>
            {getCopySegments(paragraph, action).map(({ value, bold }, i) => (
              <span key={i} className={bold ? classes.textBold : undefined}>
                {value}
              </span>
            ))}
          </Typography>
        ))}
        {stage === GATE_STAGE.requesting && (
          <div className={classes.spinnerWrapper}>
            <CircularProgress className={classes.spinner} />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined" color="primary" disableTouchRipple>
          {geolocationCopy.cancelLabel}
        </Button>
        {stage !== GATE_STAGE.requesting && (
          <Button onClick={onPrimary} variant="contained" color="primary" disableTouchRipple>
            {copy.primaryLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default LocationGateModal;
